import {
    explanationText,
    explanationAcceptManageText,
    privacyStatementText,
    manage,
    accept,
} from './TargetedAdsPrompt.locstring.json';
import loc from 'owa-localize';
import { acceptTargetedAds, manageAdsOptions } from '../actions/internalActions';
import shouldPrompt from '../selectors/shouldPrompt';
import { observer } from 'mobx-react-lite';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { DialogFooter } from '@fluentui/react/lib/Dialog';
import { Modal } from '@fluentui/react/lib/Modal';
import { logUsage } from 'owa-analytics';
import { lightable, lighted, LightningId, LightningProps } from 'owa-lightning-v2';
import { getPackageBaseUrl } from 'owa-config';

import * as React from 'react';
import { resolve as resolveUrl } from 'url';

const styles = require('./TargetedAdsPrompt.scss');

export default function TargetedAdsPrompt() {
    return (
        <LightableTargetedAdsPrompt
            lid={LightningId.TargetedAdsGdprPrompt}
            when={lightUpTargetedAdsPrompt}
        />
    );
}

const LightableTargetedAdsPrompt = lightable(
    observer(function LightableTargetedAdsPrompt(props: LightningProps) {
        const onManageButtonClicked = () => {
            lighted(props.lid);
            manageAdsOptions();
            logUsage('gdprAdPromptManageClick');
        };

        const onAcceptClicked = () => {
            lighted(props.lid);
            acceptTargetedAds();
            logUsage('gdprAdPromptAcceptClick');
        };

        const onDismissClicked = () => {
            lighted(props.lid);
            acceptTargetedAds();
            logUsage('gdprAdPromptDismissClick');
        };

        const imageUrl = resolveUrl(
            getPackageBaseUrl(),
            'resources/images/refresh-fre/fastsearch.png'
        );

        return (
            <Modal isOpen={true} onDismiss={onDismissClicked}>
                <div className={styles.content}>
                    <div className={styles.imageWrapper}>
                        <img className={styles.image} src={imageUrl} />
                    </div>
                    <div className={styles.textAndButtons}>
                        <div className={styles.textSection}>
                            <div>{loc(explanationText)}</div>
                            <div>{loc(explanationAcceptManageText)}</div>
                        </div>
                        <DialogFooter>
                            <DefaultButton
                                className={styles.linkButton}
                                onClick={onPrivacyStatmentClicked}
                                text={loc(privacyStatementText)}
                            />
                            <DefaultButton onClick={onManageButtonClicked} text={loc(manage)} />
                            <PrimaryButton onClick={onAcceptClicked} text={loc(accept)} />
                        </DialogFooter>
                    </div>
                </div>
            </Modal>
        );
    })
);

function onPrivacyStatmentClicked() {
    const privacyStatementUrl = 'https://privacy.microsoft.com/privacystatement';
    window.open(privacyStatementUrl, '_blank');
}

async function lightUpTargetedAdsPrompt(lightUp: () => void) {
    if (await shouldPrompt()) {
        lightUp();
    }
}
